export default __webpack_public_path__ + "static/media/press-05.d3a9d0b1.jpg";